var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"purchase-tab"},[_c('div',{staticClass:"tab-content"},[_c(_vm.activeComponent,{tag:"component"})],1)])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }